import type { TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'

export const skeletons: TSkeletons = [
  {
    width: '100%',
    height: '186px',
  },
]
